import { API_BASE_URL } from "../config/apiBaseUrl";

const ADMIN_BASE = "/api/admin/automotive";
const PUBLIC_BASE = "/api/v1/automap";

function authHeaders() {
  return { credentials: "include", headers: { "Content-Type": "application/json" } };
}

function qs(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v != null && v !== "") search.set(k, v);
  });
  const q = search.toString();
  return q ? `?${q}` : "";
}

export async function fetchExpansionDashboard() {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/expansion/dashboard`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar expansión.");
  return res.json();
}

export async function fetchExpansionCities(filters = {}) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/expansion/cities${qs(filters)}`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar ciudades.");
  return res.json();
}

export async function createExpansionCity(body) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/expansion/cities`, {
    method: "POST",
    ...authHeaders(),
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "No se pudo crear ciudad.");
  }
  return res.json();
}

export async function fetchExpansionCity(citySlug) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/expansion/cities/${encodeURIComponent(citySlug)}`, authHeaders());
  if (!res.ok) throw new Error("Ciudad no encontrada.");
  return res.json();
}

export async function updateExpansionCity(citySlug, body) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/expansion/cities/${encodeURIComponent(citySlug)}`, {
    method: "PATCH",
    ...authHeaders(),
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error("No se pudo actualizar ciudad.");
  return res.json();
}

export async function fetchCityReadiness(citySlug) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/expansion/cities/${encodeURIComponent(citySlug)}/readiness`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar readiness.");
  return res.json();
}

export async function fetchCityDealerPipeline(citySlug) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/expansion/cities/${encodeURIComponent(citySlug)}/dealers`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar pipeline.");
  return res.json();
}

export async function fetchCityInventoryReadiness(citySlug) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/expansion/cities/${encodeURIComponent(citySlug)}/inventory`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar inventario.");
  return res.json();
}

export async function fetchCitySeoReadiness(citySlug) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/expansion/cities/${encodeURIComponent(citySlug)}/seo`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar SEO.");
  return res.json();
}

export async function generateCitySeoConfigs(citySlug) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/expansion/cities/${encodeURIComponent(citySlug)}/seo/generate`, {
    method: "POST",
    ...authHeaders(),
  });
  if (!res.ok) throw new Error("No se pudo generar SEO.");
  return res.json();
}

export async function fetchCityCampaigns(citySlug) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/expansion/cities/${encodeURIComponent(citySlug)}/campaigns`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar campañas.");
  return res.json();
}

export async function generateCityCampaigns(citySlug) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/expansion/cities/${encodeURIComponent(citySlug)}/campaigns/generate`, {
    method: "POST",
    ...authHeaders(),
  });
  if (!res.ok) throw new Error("No se pudo generar campañas.");
  return res.json();
}

export async function fetchCityPlacements(citySlug) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/expansion/cities/${encodeURIComponent(citySlug)}/placements`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar placements.");
  return res.json();
}

export async function fetchCityExpansionAnalytics(citySlug, range = "last_30_days") {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/expansion/cities/${encodeURIComponent(citySlug)}/analytics${qs({ range })}`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar analytics.");
  return res.json();
}

export async function completeCityChecklistItem(citySlug, itemKey) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/expansion/cities/${encodeURIComponent(citySlug)}/checklist/complete`, {
    method: "POST",
    ...authHeaders(),
    body: JSON.stringify({ itemKey }),
  });
  if (!res.ok) throw new Error("No se pudo actualizar checklist.");
  return res.json();
}

export async function fetchPublicExpansionCities() {
  const res = await fetch(`${API_BASE_URL}${PUBLIC_BASE}/expansion/public-cities`);
  if (!res.ok) return { publicSlugs: [], excludedSlugs: [] };
  return res.json();
}

export function trackCityExpansionEvent(eventType, metadata = {}) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.debug("[city-expansion-event]", eventType, metadata);
  }
}
